<script lang="ts" setup>
import type { VideoPlayerProps } from './VideoPlayer.vue'

defineProps<{
  options: VideoPlayerProps['options']
}>()

const emit = defineEmits(['on-close'])

const { bodyLock, bodyUnlock } = useBodyLock()

function onClick() {
  emit('on-close')
  bodyUnlock()
}

const isCloseButtonVisible = ref(true)

onMounted(() => {
  bodyLock()
})
</script>

<template>
  <div class="fixed left-0 top-0 z-50 h-full w-full">
    <VideoPlayer
      :options="options"
      class="h-full w-full"
      :dispose-delay="1000"
      @useractive="isCloseButtonVisible = true"
      @userinactive="isCloseButtonVisible = false"
    />
    <Transition name="button">
      <Button
        v-show="isCloseButtonVisible"
        variant="cta"
        class="!absolute right-4 top-4 z-[1] md:right-5 md:top-5 [&>span:last-child]:w-9 [&>span:last-child]:px-0 [&>span:last-child]:lg:w-10"
        type="button"
        @click="onClick()"
      >
        <Icon name="close" />
      </Button>
    </Transition>
  </div>
</template>
